export default __webpack_public_path__ + "static/012-e39fd5069300bd127bc82a20c9a01b77.jpg";